import { inject } from "vue";
const breakpointsInjectionKey = Symbol("breakpointsInjection");
const breakpointsPlugin = (app, { breakpoints }) => {
  app.provide(breakpointsInjectionKey, breakpoints);
};
const useBreakpoints = () => {
  const breakpointsInjection = inject(breakpointsInjectionKey);
  if (breakpointsInjection === void 0) {
    throw new Error("Breakpoints injection was not provided");
  }
  return breakpointsInjection;
};
export { breakpointsPlugin, useBreakpoints };
